import { AllowReadonly, checkRole } from '@feedyou/utils'
import { rolesArray } from '../constants/roles'

export function getAllRolesUpToTarget(
  targetRole: string | undefined,
  initialRoleSet: AllowReadonly<string[]> = rolesArray
): string[] {
  return initialRoleSet.filter(role =>
    // @ts-ignore
    checkRole({ role: targetRole, minRequiredRole: role })
  )
}
